const state = {
  isLogin: false,
  autoLogin: false,
  navVisible: true,
  gnbVisible: false,
  lnbVisible: false,
  footerVisible: false,
  adminLnbVisible: false,
  adminGnbVisible: false,
  navbarState: "0",
  adminNavbarState: "0",
  userId: "",
  weddingHall: "",
  email: "",
  mobileNo: "",
  username: "",
  alarmCount: 0,
  isAdmin: false,
  week: "",
  day: "",
  isCollapse: false,
};

export default state;
